import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  absolute: {
    position: "absolute",
    left: 3,
  },
  backgroundPrimary: {
    backgroundColor: theme.props.background,
  },
}));

export default useStyle;
